import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20 section-padding">
        <div className="container mx-auto max-w-3xl">
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-8">
            Mentions légales
          </h1>

          <div className="prose prose-lg max-w-none text-muted-foreground space-y-8">
            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                1. Éditeur du site
              </h2>
              <p>
                Le site GoBledPro est édité par :<br />
                <strong className="text-foreground">[Nom de la société]</strong><br />
                [Forme juridique] au capital de [montant] euros<br />
                Siège social : [Adresse complète]<br />
                RCS : [Ville] [Numéro]<br />
                SIRET : [Numéro SIRET]<br />
                TVA intracommunautaire : [Numéro TVA]
              </p>
              <p>
                Directeur de la publication : [Nom du directeur]<br />
                Contact : gobledpro@gmail.com
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                2. Hébergement
              </h2>
              <p>
                Le site est hébergé par :<br />
                <strong className="text-foreground">[Nom de l'hébergeur]</strong><br />
                [Adresse de l'hébergeur]<br />
                Téléphone : [Numéro de téléphone]
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                3. Activité
              </h2>
              <p>
                GoBledPro est une plateforme de mise en relation entre des clients 
                souhaitant envoyer des colis entre la France (et l'Europe) et le Maroc, 
                et des transporteurs professionnels indépendants.
              </p>
              <div className="bg-secondary/10 border border-secondary/20 rounded-xl p-4 my-4">
                <p className="text-secondary font-medium">
                  ⚠️ GoBledPro n'est pas un transporteur. Nous agissons uniquement en qualité 
                  de plateforme de mise en relation. Le transport est réalisé par des 
                  transporteurs indépendants.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                4. Propriété intellectuelle
              </h2>
              <p>
                L'ensemble du contenu de ce site (textes, images, logos, vidéos, 
                graphismes, etc.) est protégé par les lois relatives à la propriété 
                intellectuelle. Toute reproduction, représentation, modification, 
                publication ou adaptation de tout ou partie des éléments du site, 
                quel que soit le moyen ou le procédé utilisé, est interdite sans 
                autorisation écrite préalable de GoBledPro.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                5. Données personnelles
              </h2>
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD) 
                et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, 
                de rectification, de suppression et de portabilité de vos données 
                personnelles. Pour exercer ces droits, vous pouvez nous contacter à 
                l'adresse : gobledpro@gmail.com
              </p>
              <p>
                Pour plus d'informations sur la gestion de vos données personnelles, 
                consultez notre Politique de confidentialité.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                6. Cookies
              </h2>
              <p>
                Le site GoBledPro utilise des cookies pour améliorer l'expérience 
                utilisateur et à des fins statistiques. En naviguant sur le site, 
                vous acceptez l'utilisation de cookies conformément à notre 
                politique de confidentialité.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                7. Contact
              </h2>
              <p>
                Pour toute question relative aux présentes mentions légales, 
                vous pouvez nous contacter :<br />
                Par email : gobledpro@gmail.com<br />
                Par téléphone : +33 9 55 44 39 02<br />
                Par courrier : Paris, France
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-semibold text-foreground mb-4">
                8. Droit applicable
              </h2>
              <p>
                Les présentes mentions légales sont régies par le droit français. 
                En cas de litige, les tribunaux français seront seuls compétents.
              </p>
            </section>

            <p className="text-sm text-muted-foreground pt-8 border-t border-border">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MentionsLegales;
